import { Avatar } from "@mui/material";

function getColorByAlphabet(letter) {
  if ("ABC".includes(letter)) return "#876868ff"; // brown
  if ("DEF".includes(letter)) return "#b631b4ff"; // red
  if ("GHI".includes(letter)) return "#81c784"; // green
  if ("JKL".includes(letter)) return "#e7791aff"; // green
  if ("MNOPQR".includes(letter)) return "#64b5f6"; // blue
  if ("STU".includes(letter)) return "#1e76beff"; // blue
  return "#ffb74d"; // orange
}

export default function ContactAvatar({ nameItem, photoItem, borderColor }) {
  const name = nameItem || "";
  const photo = photoItem || "";
  const firstLetter = name.charAt(0).toUpperCase();

  return (
    <Avatar
      alt={name}
      src={photo}
      sx={{
        bgcolor: photo ? "transparent" : getColorByAlphabet(firstLetter),
        color: "white", // text color inside avatar
        border: !!borderColor && `1px solid ${borderColor}`, // border color 1px solid #074062
      }}
    >
      {!photo && firstLetter}
    </Avatar>
  );
}
